import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CxHeartBeatModule } from '@bbraun/cortex/heart-beat';

import { SplashScreenComponent } from './splash-screen.component';


@NgModule({
  declarations: [SplashScreenComponent],
  exports: [SplashScreenComponent],
  imports: [
    CommonModule,
    CxHeartBeatModule
  ]
})
export class SplashScreenModule { }
